<template>
<div class="search_container searchArea">
    <el-form :inline="true" :model='searchInfo' ref="searchInfo" :rules="rules">
        <el-form-item label="热搜关键词">
            <el-input v-model="searchInfo.name" @change="nameChange" clearable></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" round @click="searchList()">查询</el-button>
            <el-button type="primary" round @click="addRS()">新增热搜</el-button>
        </el-form-item>

    </el-form>
</div>
</template>

<script>
import {
    mapGetters
} from 'vuex'

export default {
    name: 'searchItem',
    props: {
        searchInfo: {
            type: Object,
            required: true
        }

    },
    data() {
        return {
            rules: {}
        }
    },
    computed: {},
    created() {},
    methods: {
        // 查询
        searchList() {
            this.$emit('searchList', this.searchInfo)
        },
        addRS(){
             this.$emit('addRC')
        },
        nameChange(e) {
            this.searchInfo.name = e
            this.$emit('update:searchInfo', this.searchInfo)
        }
    }
}
</script>

<style>
.search_container {
    padding: 40px 0 18px;
    border-bottom: 1px solid #eff1f4;
}
.el-date-editor .el-range-separator{
    padding:0;
}
</style>
